import { useState, useEffect } from 'react';
import axios from 'axios';

export const login = async (url: string, item: any) => {
	try{
		const response = await axios.post(url, item);
		return response.data
	} catch(err: any){
		return 401
	}
}

export const createItem = async (url: string, newItem: any, token: string) => {
	try {
		const response = await axios.post(url, newItem, {
			headers: {
				"Authorization": `Bearer ${token}`,
				"Content-Type": "application/json"
			}
		});
		return response.data
	} catch (err: any) {
		return(401)
	}
};

export const getItem = async (url: string, token: string) => {
	try {
		const response = await axios.get(url, {
			headers: {
				"Authorization": `Bearer ${token}`,
				"Content-Type": "application/json"
			}
		});
		return response.data
	} catch (err) {
		return 401
	}
};

export const updateItem = async (url: string, data: any, token: string) => {
	try {
	  const response = await axios.patch(url, data, {
		headers: {
		  Authorization: `Bearer ${token}`,
		  'Content-Type': 'application/json'
		}
	  });
	  return(response.data);
	} catch (error) {
	  return 401
	}
};

export const deleteItem = async (url: string, token: string) => {
	try {
	  const response = await axios.delete(url, {
		headers: {
		  Authorization: `Bearer ${token}`,
		  'Content-Type': 'application/json'
		}
	  });
	  return(response.data);
	} catch (error) {
	  return 401
	}
};